import type { ReactNode } from "react";
import styled from "styled-components";
import { black, grayDark } from "../styles/colors";

type MessageScreenProps = {
  title: string;
  message: string;
  children?: ReactNode;
};

/** Full-height centered layout shared by the standalone status pages. */
export function MessageScreen({
  title,
  message,
  children,
}: MessageScreenProps) {
  return (
    <Centered>
      <Title>{title}</Title>
      <Message>{message}</Message>
      {children}
    </Centered>
  );
}

export const MessageActions = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

const Centered = styled.main({
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "2rem",
  textAlign: "center",
  gap: 12,
  color: black,
});

const Title = styled.h1({
  fontSize: "1.5rem",
  margin: 0,
});

const Message = styled.p({
  color: grayDark,
  maxWidth: "24rem",
  margin: 0,
});
